import Flex from 'components/Flex'
import HeartFilled from 'components/icons/HeartFilled'
import HeartIcon from 'components/icons/HeartIcon'
import LeftArrowIcon from 'components/icons/LeftArrowIcon'
import AcceptDrawer from 'modules/Roles/Partials/ViewIndividualRole/AcceptOrRejectDrawer/index'
import AboutUs from 'modules/Roles/Partials/ViewIndividualRole/Components/AboutUs'
import JobDetails from 'modules/Roles/Partials/ViewIndividualRole/Components/JobDetails'
import {
  AcceptAndSaveFlex,
  AcceptButton,
  HeartIconSpan,
  JobDetailsSpan,
  JobDetailsTab,
  JobDetailsTabPane,
  LeftArrowSpan,
  RoleInfoFlex,
  RoleSpan,
  RolesAvatar,
  RolesHeaderDiv,
  SectionWrapper,
  TopHeader,
  TopRoleSection,
} from 'modules/Roles/Partials/ViewIndividualRole/Style/style'
import {
  corporateAboutUs,
  getJobDetails,
  jobSharingEmail,
  updatePageNum,
  updateRoleData,
} from 'modules/Roles/actions.js'
import React, { Fragment, useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import {
  permittedEventCruds,
  permittedSubEventCruds,
} from '../../../../utils/permissionsValidation'
import ShareDrawer from './Components/ShareDrawer/index'
import { Spin } from 'antd'
const ViewIndividualRole = ({
  roleData,
  singleRoleDetails,
  instituteCampusId,
  corporateDetails,
  pageNum,
}) => {
  const [newAcceptOrRejectDrawer, setNewAcceptOrRejectDrawer] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = new URLSearchParams(window.location.search)
  const roleId = params.get('roleId')
  const corporateId = params.get('corporateId')
  const permissions = useSelector(state => state?.auth?.permissions)

  useEffect(() => {
    if (roleId && corporateId) {
      let payLoad = {
        id: roleId,
        corporateId: corporateId,
      }
      dispatch(getJobDetails(payLoad))
      dispatch(corporateAboutUs(corporateId))
    }
  }, [roleId])
  const handleArrow = () => {
    navigate({
      pathname: '/roles',
      search: `?page=${pageNum}`,
    })
  }
  useEffect(() => {
    return () => {
      dispatch(updatePageNum(0))
    }
  }, [])

  const onDrawerClose = flag => {
    setNewAcceptOrRejectDrawer(flag)
    let payLoad = {
      id: singleRoleDetails?.id,
      corporateId: singleRoleDetails?.corporateId,
    }
    dispatch(getJobDetails(payLoad))
  }
  const onSaveHandler = () => {
    let status = singleRoleDetails?.jobRoleInstituteMap[0]?.saved
    dispatch(
      updateRoleData({
        id: singleRoleDetails.id,
        saved: status == 0 ? '1' : '0',
      })
    )
  }

  const subEvents = permittedSubEventCruds(permissions, 'Roles')?.map(
    permission => permission?.subEvents?.subEventName?.toUpperCase()
  )
  const cruds = permittedEventCruds(permissions, 'Roles')?.map(permission =>
    permission?.events?.eventName?.toUpperCase()
  )

  return (
    <Fragment>
      {singleRoleDetails?.id ? (
        <Fragment>
          <SectionWrapper column>
            <TopHeader column>
              <Flex spaceBetween>
                <TopRoleSection>
                  <LeftArrowSpan onClick={handleArrow}>
                    <LeftArrowIcon />
                  </LeftArrowSpan>
                  <RoleSpan onClick={handleArrow}>Role</RoleSpan>
                  <JobDetailsSpan>/</JobDetailsSpan>
                  <JobDetailsSpan> Job Details</JobDetailsSpan>
                </TopRoleSection>
                <AcceptAndSaveFlex>
                  <HeartIconSpan>
                    {singleRoleDetails?.jobRoleInstituteMap[0]?.saved == 0 ? (
                      <HeartIcon onClick={onSaveHandler} />
                    ) : (
                      <HeartFilled onClick={onSaveHandler} />
                    )}
                  </HeartIconSpan>
                  <ShareDrawer
                    subEvents={subEvents}
                    singleRoleDetails={singleRoleDetails}
                    jobSharingEmail={jobSharingEmail}
                  />
                  {cruds?.includes?.('ACCEPT/REJECT') && (
                    <AcceptButton
                      height={'32px'}
                      width={'121px'}
                      text="Accept/Reject"
                      onClick={() => setNewAcceptOrRejectDrawer(true)}
                      disabled={
                        singleRoleDetails?.jobRoleInstituteMap[0]?.status == 1
                      }
                    />
                  )}
                </AcceptAndSaveFlex>
              </Flex>
              <Flex>
                <RolesAvatar
                  background
                  src={singleRoleDetails?.corporate?.logo}
                  size={90}
                  IconName={singleRoleDetails?.corporate?.name?.split('')[0]}
                  font={18}
                />

                <RolesHeaderDiv>
                  {singleRoleDetails?.corporate?.name}
                </RolesHeaderDiv>
              </Flex>
            </TopHeader>

            <RoleInfoFlex>
              <JobDetailsTab defaultActiveKey="1">
                <JobDetailsTabPane tab="Job Details" key="1">
                  {Object.keys(singleRoleDetails).length ? (
                    <JobDetails singleRoleDetails={singleRoleDetails} />
                  ) : null}
                </JobDetailsTabPane>
                <JobDetailsTabPane tab="About us" key="2">
                  {Object.keys(singleRoleDetails).length ? (
                    <AboutUs
                      roleData={roleData}
                      singleRoleDetails={singleRoleDetails}
                      corporateDetails={corporateDetails}
                    />
                  ) : null}
                </JobDetailsTabPane>
              </JobDetailsTab>
            </RoleInfoFlex>
          </SectionWrapper>
          <AcceptDrawer
            newAcceptOrRejectDrawer={newAcceptOrRejectDrawer}
            setnewAcceptOrRejectDrawer={onDrawerClose}
            instituteCampusId={instituteCampusId}
            jobId={singleRoleDetails?.id}
            roleStatus={singleRoleDetails?.jobRoleInstituteMap[0]?.status}
          />
        </Fragment>
      ) : (
        <Spin
          tip="Loading"
          size="small"
          style={{
            display: 'flex',
            width: '90vw',
            height: '95vh',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      )}
    </Fragment>
  )
}

const mapStateToProps = state => ({
  singleRoleDetails: state.roles.singleRoleDetails,
  roleData: state.roles.roleData,
  instituteCampusId: state.auth.instituteDetails.id,
  corporateDetails: state.roles.corporateDetails,
  pageNum: state.roles.pageNum,
})

export default connect(mapStateToProps)(ViewIndividualRole)
